export default "__VITE_ASSET__Gl$lf9w2__"